import {
  InputGroupV2,
  TextAreaInputV2,
  ValidationMessage,
} from '@equip.health/ui';

import { GROUP_CLASS_DESCRIPTION_LIMIT } from '~/lib/constants/calendar.constants';
import { ValidationType } from '~/lib/constants/enumeration.constants';
import {
  GroupClassBaseFieldProps,
  GROUP_CLASS_ACCORDION_TOP_LEVEL_ID,
} from '~/lib/types/classes/GroupClassAccordion';

export const GroupClassDescriptionField = ({
  value,
  isEditMode,
  onChange,
}: GroupClassBaseFieldProps<string>) => {
  const isLengthy = value?.length > GROUP_CLASS_DESCRIPTION_LIMIT;
  const isEmpty = isEditMode && value?.length === 0;
  const errorMessage = isLengthy
    ? `Description character limit is ${GROUP_CLASS_DESCRIPTION_LIMIT}`
    : null;

  return (
    <InputGroupV2
      id={`${GROUP_CLASS_ACCORDION_TOP_LEVEL_ID}__description-v2-group`}
      isRequired
      label="Description"
      shouldShowAsteriskWhenRequired
    >
      <TextAreaInputV2
        height="150px"
        id={`${GROUP_CLASS_ACCORDION_TOP_LEVEL_ID}__description-v2`}
        isInvalid={isLengthy || isEmpty}
        onChange={(value) => onChange(value)}
        value={value}
      />
      {errorMessage && (
        <ValidationMessage
          id={`${GROUP_CLASS_ACCORDION_TOP_LEVEL_ID}__description-error`}
          type={ValidationType.CRITICAL}
          value={errorMessage}
        />
      )}
    </InputGroupV2>
  );
};
